import { render, staticRenderFns } from "./SituacaoAgendamento.vue?vue&type=template&id=0c088172&"
import script from "./SituacaoAgendamento.vue?vue&type=script&lang=js&"
export * from "./SituacaoAgendamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports